import React, { FC } from "react";
import { FormBaseType } from "@green0meter/api-client";

import Form from "@components/main/vsme/hub/Form";

const VsmeFormPage: FC = () => <Form formBaseType={FormBaseType.VSME} />;

export default VsmeFormPage;
